import {
	SET_FORM_STATE
} from '../actions/ReportSmallCellsImpactActions';

const initialState = {
	formState:
	{
		isValid: false,
		values: {},
		touched: {},
		errors: {}
	},
};

const ReportSmallCellsImpactReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					default: {
						return state;
					}
	}
};

export default ReportSmallCellsImpactReducer;
